import react from 'react'
import PEN_ATTENTION from '../Pen/penAttention'

import { getSectionById } from '../../../Assets/TestData/sectionsData'

interface SectionAttention_Props {
  sectionId: number
  onPenClick?: (penId: number) => void
}
/**
 * SECTION_ATTENTION
 * @param sectionId Unique identifier for each section.
 * @param onPenClick OnClick event to handle penId.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_ATTENTION({ sectionId }: SectionAttention_Props) {
  const section = getSectionById(sectionId);

  // Error throwback if no section number excists
  if (!section) {
    return <div>Section {sectionId} not found</div>;
  }

  const renderContent = () => {
    return section.pens.map(pen => (
      <PEN_ATTENTION
        key={pen.animal?.animalId}
        penId={pen.penId}
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "fit-content", gap: "10px", borderRadius: "10px", overflow: "hidden" }}>
          {renderContent()}
        </div>
      </div>
  );
}